import { render, staticRenderFns } from "./StockistProcessedOrders.vue?vue&type=template&id=2f7ed3c4"
import script from "./StockistProcessedOrders.vue?vue&type=script&lang=js"
export * from "./StockistProcessedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports